var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pic-wrapper frame-gold-tl"},[_c('img',{staticClass:"_pic",attrs:{"src":"/imgs/profile-pic.jpg","alt":"Profile Picture"}})])}]

export { render, staticRenderFns }